module.exports = __webpack_public_path__ + "img/email1.sh.245c79da.svg";